
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/area",
      function () {
        return require("private-next-pages/area.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/area"])
      });
    }
  